@if (formGroup?.get(controlName)?.touched && formGroup?.get(controlName)?.errors && !isCheckTouch) {
  <mat-hint class="text-danger title-11"
    >
    {{errorMessagingService.getFormControlErrorMessage(controlName, formGroup?.get(controlName)?.errors)}}
  </mat-hint>
}

@if (formGroup?.get(controlName)?.errors && isCheckTouch) {
  <mat-hint class="text-danger title-11">
    {{errorMessagingService.getFormControlErrorMessage(controlName, formGroup?.get(controlName)?.errors)}}
  </mat-hint>
}